import React, { useState, useEffect } from 'react';
import ino from '../../assets/ino.png';
import './flowerCalculator.css';
import { BiReset } from 'react-icons/bi';
import {
  FcLowPriority,
  FcMediumPriority,
  FcHighPriority,
} from 'react-icons/fc';

const FlowerCalculator = () => {
  const [flowersLowDrop, setFlowersLowDrop] = useState(0);
  const [flowersMediumDrop, setFlowersMediumDrop] = useState(0);
  const [flowersHighDrop, setFlowersHighDrop] = useState(0);
  const [potion10Energy, setPotion10Energy] = useState(' ');
  const [potion50Energy, setPotion50Energy] = useState(' ');
  const [energy, setEnergy] = useState(' ');

  useEffect(() => {
    const calculateFlowers = () => {
      let result = potion10Energy * 10 + potion50Energy * 50 + energy;
      if (isNaN(result)) {
        return;
      }
      setFlowersLowDrop(result / 120);
      setFlowersMediumDrop(result / 104);
      setFlowersHighDrop(result / 96);
    };
    calculateFlowers();
  }, [potion10Energy, potion50Energy, energy]);

  const re = /^[0-9\b]+$/;
  const handlePotion10Energy = (e) => {
    if (re.test(e.target.value)) {
      setPotion10Energy(e.target.valueAsNumber);
    } else {
      setPotion10Energy(0);
    }
  };

  const handlePotion50Energy = (e) => {
    if (re.test(e.target.value)) {
      setPotion50Energy(e.target.valueAsNumber);
    } else {
      setPotion50Energy(0);
    }
  };

  const handleEnergy = (e) => {
    if (re.test(e.target.value)) {
      setEnergy(e.target.valueAsNumber);
    } else {
      setEnergy(0);
    }
  };

  const handleReset = () => {
    setPotion10Energy(' ');
    setPotion50Energy(' ');
    setEnergy(' ');
  };

  return (
    <div className="flowerCalculatorContainer">
      <div className="flowerCalculatorModal">
        <h2 className="flowerTitle">Calculador &nbsp; de &nbsp; flores</h2>
        <div className="flowerCalculatorSetting">
          <img src={ino} alt="Ino" className="ino" />
          <div className="flowerCalculator">
            <BiReset className="resetField" onClick={handleReset} />

            <label htmlFor="energy" className="flowerCalculatorTitle">
              Cantidad de energía
            </label>
            <input
              type="number"
              onChange={(e) => handleEnergy(e)}
              value={energy}
              className="inputField"
              id="energy"
            />
            <label htmlFor="potion10Energy" className="flowerCalculatorTitle">
              Cantidad de pociones chicas (10 energía)
            </label>
            <input
              type="number"
              onChange={(e) => handlePotion10Energy(e)}
              value={potion10Energy}
              className="inputField"
              id="potion10Energy"
            />
            <label htmlFor="potion60Energy" className="flowerCalculatorTitle">
              Cantidad de pociones grandes (50 energía)
            </label>
            <input
              type="number"
              onChange={(e) => handlePotion50Energy(e)}
              value={potion50Energy}
              className="inputField"
              id="potion60Energy"
            />
            <div className="flowerCalculatorResultContainer">
              <p className="flowerCalculatorResult">Cantidad de flores</p>
              <div className="flowersLowDrop">
                <FcLowPriority /> Low drop {Math.floor(flowersLowDrop)} flores
              </div>
              <div className="flowersMediumDrop">
                <FcMediumPriority /> Medium drop {Math.floor(flowersMediumDrop)}{' '}
                flores
              </div>
              <div className="flowersHighDrop">
                <FcHighPriority color="white" /> High drop{' '}
                {Math.floor(flowersHighDrop)} flores
              </div>
            </div>
            <p className="flowersDisclaimer">
              Disclaimer: Los cálculos fueron realizados basándonos en
              resultados obtenidos por los jugadores. Por tanto, tenga en cuenta
              que son aproximaciones.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlowerCalculator;
